var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainPageImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 184,
    viewBox: "0 0 1920 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.574 96.7211C128.17 22.9524 41.8551 1.50345 0 1.50133e-05H57.4093L114.315 1.11986e-05C430.862 -1.39983e-05 474.33 1.11986e-05 474.33 1.11986e-05C423.303 -0.000171302 418.987 55.4105 394.209 95.7469C382.202 115.292 331.676 121.835 313.667 86.2253C298.339 55.9179 295.043 32.5957 256.137 35.5815C223.12 38.1153 208.112 64.8396 208.112 113.788C208.112 183.949 186.259 183.09 176.595 183.949C159.983 185.425 143.216 155.02 136.574 96.7211Z",
    fill: "#4AC7CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.79 1.11986e-05C1296.81 0.541128 1374.42 10.9249 1387.23 96.7211C1403.23 203.966 1456.76 182.417 1465.27 159.866C1473.77 137.314 1480.77 43.0986 1511.79 42.0963C1542.81 41.0941 1540.81 84.6935 1544.81 90.7073C1548.81 96.7211 1566.32 118.27 1579.83 90.7073C1593.33 63.1443 1606.78 0.000517845 1657.87 11.5264C1669.87 17.3731 1694.89 41.3945 1698.89 90.7073C1703.89 152.348 1743.91 133.806 1749.42 108.749L1749.56 108.099C1755.09 82.8923 1765.2 36.8307 1811.45 21.0481C1856.97 5.51259 1900.99 3.84212 1920 1.14441e-05L1251.79 1.11986e-05Z",
    fill: "#4AC7CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPageImage2);
export default __webpack_public_path__ + "static/media/mainPageImage2.3b58ed78458aa3628ed9bb827a1df6ec.svg";
export { ForwardRef as ReactComponent };